import { render, staticRenderFns } from "./DeTermsOfUse.vue?vue&type=template&id=2365d649&scoped=true"
import script from "./DeTermsOfUse.vue?vue&type=script&lang=js"
export * from "./DeTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2365d649",
  null
  ,true
)

export default component.exports